import * as ko from 'knockout';
import { serializeDate } from '../../api/serialization';
import { app } from '../../app';
import i18n from '../../i18n';

import { Deferred } from '../../utils/deferred';
import { createWithComponent } from '../../utils/ko_utils';
import { uuid4 } from '../../utils/uuid';
import { DataEntryVisitData, saveVisitDate } from '../data_entry_api';

const template = require('raw-loader!./data_entry_duplicate_visit.html').default;

class DataEntryDuplicateVisit {
  private trialId: string;
  private visit: DataEntryVisitData;
  private result: Deferred<string | null>;

  value = ko.observable<Date>(new Date()).extend({ required: true });
  saving = ko.observable(false);

  constructor(params: {
    trialId: string;
    visit: DataEntryVisitData;
    result: Deferred<string | null>;
  }) {
    this.trialId = params.trialId;
    this.visit = params.visit;
    this.result = params.result;
  }

  cancel = () => this.result.resolve(null);

  save = async () => {
    if (!this.value.isValid()) {
      return;
    }

    this.saving(true);
    try {
      const newVisitId = uuid4();
      await saveVisitDate({
        trial_id: this.trialId,
        sv_id: this.visit.sv_id,
        site_id: this.visit.site_id,
        visit_id: newVisitId,
        date: serializeDate(this.value()),
      });
      this.result.resolve(newVisitId);
    } finally {
      this.saving(false);
    }
  };
}

const dataEntryDuplicateVisit = {
  name: 'data-entry-duplicate-visit',
  viewModel: createWithComponent(DataEntryDuplicateVisit),
  template,
};

ko.components.register(dataEntryDuplicateVisit.name, dataEntryDuplicateVisit);

export function openDataEntryDuplicateVisit(
  trialId: string,
  visit: DataEntryVisitData
): Promise<string | null> {
  return app.formsStackController.push({
    title: i18n.t('Duplicate visit')(),
    name: dataEntryDuplicateVisit.name,
    params: {
      trialId,
      visit,
      result: new Deferred<string | null>(),
    },
  });
}
